module.exports = __webpack_public_path__ + "static/media/avatar_49.45fb43be.svg";